// Spawn `gh auth login --hostname github.com --web` interactive.
// User sẽ thấy device-code prompt và browser tự mở. Block đến khi xong.
import { spawnSync } from "node:child_process";
import { isNonInteractive } from "./non-interactive-context.js";
import { log } from "./terminal-logger.js";

export function triggerGhCliAuthLogin(): void {
  // ⛔ KHÔNG TREO KHI KHÔNG CÓ NGƯỜI: lệnh dưới đây `spawnSync` một luồng đăng
  // nhập OAuth với `stdio: "inherit"` — nó đợi người bấm nút trên browser, vô hạn.
  // Đây KHÔNG phải prompt của @inquirer nên `prompt-or-flag` không chặn được; phải
  // gác riêng tại đây, nếu không `--non-interactive` vẫn treo đúng cái nó sinh ra để diệt.
  if (isNonInteractive()) {
    throw new Error(
      "Chưa đăng nhập GitHub, mà `gh auth login` cần browser — không chạy được ở chế độ " +
        "non-interactive. Chạy `gh auth login` một lần trên máy này rồi gọi lại.",
    );
  }
  log.info("Khởi động đăng nhập GitHub qua gh CLI (browser sẽ mở)...");
  const r = spawnSync(
    "gh",
    ["auth", "login", "--hostname", "github.com", "--web", "--git-protocol", "ssh"],
    { stdio: "inherit" },
  );
  if (r.status !== 0) {
    throw new Error(`gh auth login thất bại (exit ${r.status}). Thử 'gh auth login' tay.`);
  }
  log.success("Đã đăng nhập GitHub");
}
